import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const SEO = ({ title, description, keywords, url }) => {
  const siteTitle = "VR Builders & Promoters";
  const defaultDescription =
    "VR Builders & Promoters - Leading construction company in Tamil Nadu. We specialize in house planning, approval, interior design, and turnkey construction.";
  const defaultKeywords =
    "construction company, house planning, building approval, interior design, home builders chennai, tamil nadu builders";
  const siteUrl = "https://vrbuildersandpromoters.com";

  return (
    <Helmet>
      {/* Basic Tags */}
      <title>{title ? `${title} | ${siteTitle}` : siteTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={url ? `${siteUrl}${url}` : siteUrl} />

      {/* Open Graph Tags (Facebook/LinkedIn) */}
      <meta property="og:title" content={title || siteTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:url" content={url ? `${siteUrl}${url}` : siteUrl} />
      <meta property="og:type" content="website" />
      {/* Add og:image if you have a specific preview image */}

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || siteTitle} />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  url: PropTypes.string,
};

export default SEO;
